(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proof-approval"]) return;
  try {
    
  (() => {
    const params = new URLSearchParams(window.location.search);
    const order = params.get('order') ?? '';
    const proof = params.get('proof') ?? '';
    const validOrder = /^[A-Za-z0-9#-]{1,20}$/.test(order);
    const validProof = /^[A-Za-z0-9._-]+\.(png|jpe?g|webp)$/i.test(proof);

    // Remembers, for this tab only, that the customer accepted vectorization, so the page
    // shown after sending can offer the service. Without storage there is simply no button.
    const storageKey = 'proof-approval-vectorization';

    for (const offer of document.querySelectorAll('.proof-approval__vectorization')) {
      if (!(offer instanceof HTMLElement)) continue;
      try {
        const saved = JSON.parse(window.sessionStorage.getItem(storageKey) ?? 'null');
        window.sessionStorage.removeItem(storageKey);
        if (saved?.accepted !== true) continue;

        const forField = offer.querySelector('input[name="properties[For]"]');
        if (forField instanceof HTMLInputElement && typeof saved.order === 'string') {
          forField.value = saved.order.slice(0, 100);
        }
        offer.hidden = false;
      } catch (error) {
        // Storage is unavailable or unreadable: leave the button hidden.
      }
    }

    // A link with sub=1 means a substitution was made: ask the customer to accept it or wait.
    // The address is used only to show this choice, never as content.
    if (params.get('sub') === '1') {
      for (const choice of document.querySelectorAll('.proof-approval__substitution')) {
        if (!(choice instanceof HTMLElement)) continue;
        for (const radio of choice.querySelectorAll('input[type="radio"]')) {
          radio.disabled = false;
          radio.required = true;
        }
        choice.hidden = false;
      }
    }

    for (const form of document.querySelectorAll('.proof-approval__form')) {
      form.addEventListener('submit', () => {
        try {
          const accept = form.querySelector('.proof-approval__vectorization-accept');
          const field = form.querySelector('input[name="contact[Order number]"]');
          if (accept instanceof HTMLInputElement && accept.checked && field instanceof HTMLInputElement) {
            window.sessionStorage.setItem(storageKey, JSON.stringify({ accepted: true, order: field.value.trim() }));
          } else {
            window.sessionStorage.removeItem(storageKey);
          }
        } catch (error) {
          // Storage is unavailable: the response is still sent.
        }
      });

      const orderField = form.querySelector('input[name="contact[Order number]"]');
      if (validOrder && orderField instanceof HTMLInputElement && orderField.value === '') {
        orderField.value = order;
      }

      if (!validProof) continue;

      const fileField = form.querySelector('input[name="contact[Proof file]"]');
      if (fileField instanceof HTMLInputElement) fileField.value = proof;

      const box = form.querySelector('.proof-approval__proof');
      if (!(box instanceof HTMLElement)) continue;

      // The address comes from Liquid's file_url for a placeholder name. Only the file
      // name at the end of its path is swapped for the validated name.
      const { filesUrl = '', placeholder = '', alt = '' } = box.dataset;
      if (filesUrl === '' || placeholder === '') continue;

      const url = new URL(filesUrl, window.location.href);
      if (!url.pathname.endsWith('/' + placeholder)) continue;
      url.pathname = url.pathname.slice(0, -placeholder.length) + encodeURIComponent(proof);

      const image = document.createElement('img');
      image.className = 'proof-approval__proof-image';
      image.alt = alt;
      image.addEventListener('error', () => {
        image.remove();
        const error = box.querySelector('.proof-approval__proof-error');
        if (error instanceof HTMLElement) error.hidden = false;
      });
      image.src = url.href;
      box.append(image);
      box.hidden = false;
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
